import color from 'color';
export const toNormalizedHueSatBr = (value) => {
    if (value) {
        try {
            const [hue, sat, lightness] = color(value).hsv().array();
            return {
                br: normalizeBr(lightness),
                hue: normalizeHue(hue),
                sat: normalizeSat(sat),
            };
        }
        catch (error) { }
    }
    return { br: 0, hue: 0, sat: 0 };
};
const defaultColorHueDeviation = 180;
/**
 *
 * Input: decimal [0..360] as produced by https://github.com/Qix-/color
 * Output: color compensated for https://static.wixstatic.com/media/5e9922_d7e0701236b0424d898945df63402533~mv2.png
 * and normalized to integer [-180..180] as accepted in WiX Media Platform API
 * https://support.wixmp.com/en/article/image-service-3835799#filters
 * http://mediacloud.wix.com/docs/image-api.html#adjustment-operations
 */
function normalizeHue(hue) {
    const result = Math.round(hue) + defaultColorHueDeviation;
    return result > 180 ? result - 360 : result;
}
function normalizeSat(sat) {
    return Math.round(sat - 100);
}
function normalizeBr(br) {
    return Math.round(br - 100);
}
//# sourceMappingURL=to-normalized-hue-sat-br.js.map